// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1vzbu","content":"GlobalSearch_content__-bHFH"};